import React, { Component } from 'react';
import classNames from 'classnames';
import DonationBox from './donation-box';
import DonationTerms from './donation-terms';
import Slider from 'react-slick';
import { get, isEmpty } from 'lodash';
import { Text } from 'pp-react';
import { SampleNextArrow, SamplePrevArrow } from './arrows';

import content from '../lib/i18n';
const i18n = content('app/components/charityMobile');

import getType from '../lib/charity';

export class charity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      charities: (props.charities || []).filter(c => {
        return !!c;
      }),
    };

    this.handleHover = this.handleHover.bind(this);
    this.renderCharity = this.renderCharity.bind(this);
  }

  handleHover() {
    this.setState({
      hover: true,
    });
  }

  renderDonationError() {
    if (
      !this.props.selectedCharity &&
      get(this.props, 'donationInfo.donated') === 2 &&
      get(this.props, 'donationInfo.source') === this.props.source
    ) {
      return (
        <div>
          <div className={'landing-chkout-error-msg-mobile'}>
            <img
              className={'iconStylingMobile'}
              src='https://www.paypalobjects.com/images/Cause/icon-alert_XS.svg'
            />
            <Text as='p' size='md' className={'errStylingMobile'}>
              {this.props.checkoutErrorMsg}
            </Text>
          </div>
        </div>
      );
    }
  }

  renderCharity() {
    let { selectedIndex, selectedIndexCharityInfo, campaignId } = this.props;
    let charityLoad = this.state.charities;

    let charity = charityLoad.map((response, index) => {
      if (selectedIndex === index || !this.props.selectedCharity) {
        let charityNameLength = response.name && response.name.length;
        let charityNameStripped = response.name;
        if (charityNameLength > 40) {
          charityNameStripped = charityNameStripped.substr(0, 40).concat('...');
        }

        const npoUrl = `${this.props.npoBaseUrl}${response.nonprofit_id}`;

        return (
          <div
            key={index}
            className={'logo-container'}
            style={{ marginLeft: '0px', marginRight: '0px' }}
          >
            <div className={'logoCharity'} onMouseOver={this.handleHover}>
              <div style={{ margin: 'auto', position: 'relative' }}>
                <div className={'npo-avatar-container'}>
                  <div
                    className={'npo-avatar'}
                    onClick={this.props.onHandleClick.bind(
                      null,
                      index,
                      this.props.source,
                      response.nonprofit_id
                    )}
                    style={{
                      background: `url(${
                        response.logo_url
                      }) no-repeat center, center`,
                      backgroundSize: 'contain',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={'charityName'}>
              <Text as='p' size='md' regular className={'charitytext'}>
                {charityNameStripped}{' '}
                <a
                  className={'infoIcon'}
                  target={'_blank'}
                  onClick={this.props.onInfoClick.bind(
                    null,
                    index,
                    this.props.source,
                    response
                  )}
                  href={npoUrl}
                >
                  <img
                    src={
                      'https://www.paypalobjects.com/images/Cause/CampaignPage/info_icon.svg'
                    }
                  />
                </a>
              </Text>
            </div>
          </div>
        );
      }
    });

    return charity;
  }

  renderCarouselPanes() {
    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };

    let charityModuleMobileStyling = classNames(
      'row inner_container col-xs-12 col-sm-6 col-md-4 col-lg-4',
      {
        stateChange: this.props.selectedCharity,
      }
    );

    let charityPaneArray = [],
      size = 4;

    let renderedCharity = this.renderCharity();

    while (renderedCharity.length > 0) {
      charityPaneArray.push(renderedCharity.splice(0, size));
    }

    let charityResp = charityPaneArray.map((result, index) => {
      return <div key={index}>{result}</div>;
    });

    let toRender;
    if (this.props.selectedCharity) {
      toRender = charityResp;
    } else {
      toRender = <Slider {...settings}>{charityResp}</Slider>;
    }

    return <div className={charityModuleMobileStyling}>{toRender}</div>;
  }

  renderMobileCharities() {
    return <div>{this.renderCarouselPanes()}</div>;
  }

  renderDonationBox() {
    const selectedCharityDetails =
      this.state.charities[this.props.selectedIndex] || {};
    return (
      <div>
        <DonationBox
          charityDetails={selectedCharityDetails}
          amounts={this.props.amounts}
          csrf={this.props.csrf}
          source={this.props.source}
          {...this.props}
        />
      </div>
    );
  }

  renderDonationTerms() {
    if (this.props.selectedCharity) {
      const charity = this.state.charities[this.props.selectedIndex] || {};
      const type = getType(charity);
      const charityContent = charity.charityContent;
      return (
        <div>
          <DonationTerms type={type} charityContent={charityContent} />
        </div>
      );
    }
  }

  render() {
    let charitytitleClassname = classNames('card_heading', {
      hide: !this.props.selectedCharity,
    });

    let backlink = classNames('back', {
      hide: !this.props.selectedCharity,
    });

    let charitytitleFirstClassname = classNames('card_heading', {
      hide: this.props.selectedCharity,
    });

    let charitysubtitleFirst = classNames('card_subheading', {
      hide:
        this.props.selectedCharity ||
        (this.props.donationInfo && this.props.donationInfo.donated === 2),
    });

    return (
      <div id='chooseCharities'>
        <div className={'panel mobileCharityPanel'}>
          <div className={'backDivStyling'}>
            <span className={backlink}>
              <img
                className={'backspanarrow'}
                src={
                  'https://www.paypalobjects.com/images/Cause/CampaignPage/ic_arrow.svg'
                }
              />
            </span>
            <Text
              as={'p'}
              size={'md'}
              className={backlink}
              onClick={this.props.onHandleDefaultCharityState.bind(
                null,
                this.props.source
              )}
            >
              {i18n('label.back-link')}
            </Text>
          </div>
          <Text as='h3' size='xl2' className={charitytitleFirstClassname}>
            {this.props.charityModuleTitle
              ? this.props.charityModuleTitle
              : this.props.charityModuleTitleDefault}
          </Text>
          {this.renderDonationError()}
          <Text
            as='h3'
            size='md'
            className={charitysubtitleFirst}
            style={{ textAlign: 'center', margin: '0 auto' }}
          >
            {this.props.charityModuleSubHeader || ''}
          </Text>
          <Text
            as='h3'
            size='xl2'
            className={charitytitleClassname}
            style={{ width: '68%', margin: '0 auto' }}
          >
            {this.props.charityModuleChooseAmountText
              ? this.props.charityModuleChooseAmountText
              : this.props.charityModuleChooseAmountTextDefault}
          </Text>
          {this.renderMobileCharities()}
          {this.renderDonationBox()}
          {this.renderDonationTerms()}
        </div>
      </div>
    );
  }
}

export default charity;
